import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})

export class TableService {
  public api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl + '/chart';
  }

  // Monthly commission generated
  public getTableMonthlyData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-opportunity-pipeline-table`, body);
  }

  public getTableCommissionData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-commission-chart-table`, body);
  }

  public getTotalCommissionData(fromDate: string, toDate: string): Observable<any> {
    return this.http.get(`${this.api}/get-total-commission-chart?fromDate=${fromDate}&toDate=${toDate}`);
  }
  // Monthly commission generated

  // Referral activity current month
  public getTableLeadData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-leads-referral-activity-table`, body);
  }

  public getTableMostRecentData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-recent-referral-activity-table`, body);
  }

  public getTableTradeAccountData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-trade-account-referral-activity-table`, body);
  }
  // end Referral activity current month

  // Monthly conversion percentage
  public getTableInSaleProcessData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-conversion-sale-process-table`, body);
  }

  public getTableConvertedRatioData(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-conversion-ratio-table`, body);
  }
  public getTableConvertedAccountData(): Observable<any> {
    return this.http.get(`${this.api}/get-conversion-converted-account-table`);
  }
  // end Monthly conversion percentage

  // Opportunity pipeline
  public getOpportunityPipelineChartTable(body: any): Observable<any> {
    return this.http.post(`${this.api}/get-opportunity-pipeline-table`, body);
  }
}
